import { useState } from 'react'
import { adminChangePassword } from '../../../services/admin'
import { PASSWORD_LENGTH_ERROR, changePasswordError } from '../signInError'

/** The server's bounds (`auth_adminChangePassword`); the form checks them first so a short one never costs a request. */
export const NEW_PASSWORD_MIN = 10
export const NEW_PASSWORD_MAX = 128

/**
 * «تغییر رمز»: the signed-in admin's own password — the current one and a
 * new one. Labels, two inputs and two buttons; the outcome is one short line.
 * After a change the server ends every other session and this one carries on
 * with the fresh pair `adminChangePassword` stores.
 */
export function ChangePassword({ onClose }) {
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const [done, setDone] = useState(false)

  async function submit(e) {
    e.preventDefault()
    if (next.length < NEW_PASSWORD_MIN || next.length > NEW_PASSWORD_MAX) { setErr(PASSWORD_LENGTH_ERROR); return }
    setBusy(true); setErr('')
    try {
      await adminChangePassword(current, next)
      setCurrent(''); setNext(''); setDone(true)
    } catch (ex) { setErr(changePasswordError(ex)) }
    finally { setBusy(false) }
  }

  const FI = 'mb-2 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none'

  return (
    <div role="dialog" aria-modal="true" aria-label="تغییر رمز"
      className="fixed inset-0 z-20 flex items-center justify-center bg-slate-900/40 p-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-md">
        <h2 className="mb-4 text-lg font-bold text-slate-800">تغییر رمز</h2>

        <label htmlFor="admin-current-password" className="mb-1 block text-sm font-medium text-slate-600">رمز فعلی</label>
        <input id="admin-current-password" name="current-password" type="password" value={current}
          onChange={e => { setCurrent(e.target.value); setDone(false) }}
          dir="ltr" className={FI} autoFocus autoComplete="current-password" />

        <label htmlFor="admin-new-password" className="mb-1 mt-1 block text-sm font-medium text-slate-600">رمز جدید</label>
        <input id="admin-new-password" name="new-password" type="password" value={next}
          onChange={e => { setNext(e.target.value); setDone(false) }}
          dir="ltr" className={FI} autoComplete="new-password" minLength={NEW_PASSWORD_MIN} maxLength={NEW_PASSWORD_MAX} />

        {err && <p role="alert" className="mt-1 text-xs text-red-600">{err}</p>}
        {done && <p role="status" className="mt-1 text-xs font-medium text-green-700">رمز تغییر کرد.</p>}

        <div className="mt-4 flex gap-2">
          <button type="submit" disabled={busy || !current || !next}
            className="flex-1 rounded-lg bg-brand-600 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-700 disabled:opacity-50">
            {busy ? 'در حال ذخیره…' : 'ذخیره'}
          </button>
          <button type="button" onClick={onClose}
            className="rounded-lg border border-slate-300 px-4 py-2 text-sm text-slate-600 hover:bg-slate-50">
            بستن
          </button>
        </div>
      </form>
    </div>
  )
}
